import {
  type InvitationToken,
  type PublicEventContentObject,
  isProgramEventAfterOpenToJoin,
  isProgramEventBeforeOpenToJoin,
} from 'models';
import { Alert } from 'ui';
import { SharedProgramEventForm } from './shared-program-event-form';

type P = {
  eventContentObject: PublicEventContentObject;
  invitationToken: InvitationToken;
};

const SharedProgramEventEnter = ({ eventContentObject, invitationToken }: P) => {
  const eventInviteRole = invitationToken.eventInviteeRole;

  if (!eventInviteRole) {
    return <Alert title="Access token is expired or invalid." type="warning" />;
  }

  if (isProgramEventBeforeOpenToJoin(eventContentObject.event, eventInviteRole)) {
    return;
  }

  if (isProgramEventAfterOpenToJoin(eventContentObject.event)) {
    return <Alert title="This event has ended" />;
  }

  return <SharedProgramEventForm eventContentObject={eventContentObject} invitationToken={invitationToken} />;
};

export default SharedProgramEventEnter;
